'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'handcuffs';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4f8';
var svgPathData = 'M312-32c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zM192 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 80c-17.7 0-32 14.3-32 32l0 41.7C38.6 186.9 0 248.9 0 320 0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-41.7c0-17.7-14.3-32-32-32L128 80zm128 58.9c-20-7.1-41.6-10.9-64-10.9s-44 3.8-64 10.9l0-26.9 128 0 0 26.9zM192 160a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM320 320a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM192 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM329.3 80c4.3 9.8 6.7 20.6 6.7 32l96 0 0 22c-15.3-3.9-31.4-6-48-6-14.4 0-28.5 1.6-42 4.6 10.6 8.5 20.4 17.8 29.4 27.9 4.2-.3 8.4-.5 12.7-.5 88.4 0 160 71.6 160 160S472.4 480 384 480c-4.3 0-8.5-.2-12.7-.5-9 10.1-18.8 19.4-29.4 27.9 13.5 3 27.6 4.6 42 4.6 106 0 192-86 192-192 0-77.5-45.9-144.3-112-174.6l0-33.4c0-17.7-14.3-32-32-32L329.3 80zm84.7 148.8C452.4 241.4 480 277.5 480 320s-27.6 78.6-65.9 91.2c-5.2 12.7-11.5 24.8-18.7 36.3 65.4-5.8 116.6-60.6 116.6-127.5S460.7 198.3 395.4 192.5c7.2 11.5 13.5 23.6 18.7 36.3zM384 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandcuffs = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;